// src/lib/validate.js
// Shared input validation utilities for Death Card
// Used across all forms — keeps validation logic in one place

// ── String helpers ─────────────────────────────────────────────────────
export const isEmpty = (val) => !val || val.trim().length === 0

export const tooLong = (val, max) => val && val.trim().length > max

// Strip HTML tags to prevent XSS in text that gets rendered
export const stripHtml = (val) => val ? val.replace(/<[^>]*>/g, '') : val

// ── Field validators ─────────────────────────────────────────────────────
export const validateEmail = (email) => {
  if (isEmpty(email)) return 'Email is required'
  const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  if (!re.test(email.trim())) return 'Invalid email address'
  if (tooLong(email, 254)) return 'Email is too long'
  return null
}

export const validateCallsign = (val) => {
  if (isEmpty(val)) return 'Callsign is required'
  if (tooLong(val, 32)) return 'Callsign must be 32 characters or less'
  if (/[<>"'`]/.test(val)) return 'Callsign contains invalid characters'
  return null
}

export const validateDisplayName = (val) => {
  if (isEmpty(val)) return 'Display name is required'
  if (tooLong(val, 48)) return 'Display name must be 48 characters or less'
  if (/[<>"'`]/.test(val)) return 'Display name contains invalid characters'
  return null
}

export const validateTeamName = (val) => {
  if (isEmpty(val)) return 'Team name is required'
  if (tooLong(val, 48)) return 'Team name must be 48 characters or less'
  if (/[<>"'`]/.test(val)) return 'Team name contains invalid characters'
  return null
}

export const validateEventName = (val) => {
  if (isEmpty(val)) return 'Event name is required'
  if (tooLong(val, 80)) return 'Event name must be 80 characters or less'
  if (/[<>"'`]/.test(val)) return 'Event name contains invalid characters'
  return null
}

export const validateDescription = (val) => {
  // Optional field — only validate if provided
  if (!val || val.trim().length === 0) return null
  if (tooLong(val, 500)) return 'Description must be 500 characters or less'
  if (/[<>"'`]/.test(val)) return 'Description contains invalid characters'
  return null
}

export const validateAar = (val) => {
  if (!val || val.trim().length === 0) return null
  if (tooLong(val, 2000)) return 'AAR must be 2000 characters or less'
  return null
}

export const validateJoinCode = (val) => {
  if (isEmpty(val)) return 'Join code is required'
  if (!/^[A-Z0-9]{6}$/.test(val.trim())) return 'Join code must be 6 uppercase letters/numbers'
  return null
}

// ── Form-level validators ──────────────────────────────────────────────────
// Returns an object of { fieldName: errorMessage } or empty {}
export const validateCreateTeam = ({ name, description }) => {
  const errors = {}
  const nameErr = validateTeamName(name)
  if (nameErr) errors.name = nameErr
  const descErr = validateDescription(description)
  if (descErr) errors.description = descErr
  return errors
}

export const validateLogOp = ({ event_name, aar }) => {
  const errors = {}
  const nameErr = validateEventName(event_name)
  if (nameErr) errors.event_name = nameErr
  const aarErr = validateAar(aar)
  if (aarErr) errors.aar = aarErr
  return errors
}
